import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBetaReaderLogoAndName = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 950 138.64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1,.cls-2{fill:#fff;}.cls-2{fill-rule:evenodd;}" }) }), /* @__PURE__ */ _jsx("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Layer_1-2",
			"data-name": "Layer 1",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M197.74,18.14c5.61-1.33,14.63-2.22,23.49-2.22,12.85,0,21.13,2.22,27.18,7.24,5.18,3.85,8.43,9.75,8.43,17.58,0,9.75-6.5,18.17-16.85,21.87v.44c9.46,2.22,20.54,10,20.54,24.82A26.19,26.19,0,0,1,252,107.82c-6.8,6.35-18,9.31-34.28,9.31a150,150,0,0,1-19.94-1.19Zm12.85,40.77h11.67c13.45,0,21.43-7.23,21.43-16.84,0-11.52-8.72-16.25-21.72-16.25a55.35,55.35,0,0,0-11.38.89Zm0,47.58a70.4,70.4,0,0,0,10.79.59c13.3,0,25.56-4.88,25.56-19.35,0-13.45-11.68-19.21-25.71-19.21H210.59Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M281.25,82.85c.3,17.58,11.38,24.82,24.53,24.82,9.31,0,15.07-1.62,19.8-3.69l2.36,9.3c-4.58,2.07-12.56,4.59-23.93,4.59-22,0-35.17-14.63-35.17-36.2s12.71-38.41,33.54-38.41c23.49,0,29.55,20.38,29.55,33.53a32.25,32.25,0,0,1-.44,6.06Zm38.12-9.31c.15-8.12-3.4-21-18-21-13.3,0-18.92,12-20,21Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M359.74,27.6V44.73h18.62v9.9H359.74V93.19c0,8.87,2.51,13.89,9.75,13.89a24.3,24.3,0,0,0,7.54-.89l.59,9.9a35.3,35.3,0,0,1-11.52,1.78c-6.06,0-10.94-2.07-14-5.47-3.54-4-5-10.34-5-18.76v-39H336v-9.9H347V31.44Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M439.27,99.1a119.86,119.86,0,0,0,1,17.14H428.63l-1-9h-.44c-4,5.61-11.67,10.64-21.86,10.64-14.48,0-21.87-10.2-21.87-20.54,0-17.29,15.37-26.74,43-26.6V69.26c0-5.76-1.62-16.55-16.25-16.4a34.44,34.44,0,0,0-18.76,5.32l-3-8.72c5.91-3.69,14.63-6.2,23.64-6.2,21.87,0,27.19,14.92,27.19,29.1ZM426.71,79.75c-14.18-.3-30.29,2.21-30.29,16.1,0,8.57,5.62,12.41,12.12,12.41,9.45,0,15.51-5.91,17.58-12a14.72,14.72,0,0,0,.59-4.13Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M453.86,18.8a149.83,149.83,0,0,1,24.68-2.07c13.73,0,22.74,2.66,28.8,8.13,4.88,4.43,7.83,11.23,7.83,19.06,0,13-8.27,21.72-18.61,25.26v.44c7.53,2.66,12.11,9.75,14.48,20.1,3.25,13.88,5.61,23.49,7.68,27.33h-13.3c-1.62-3-3.84-11.38-6.5-23.79C496,79.52,490.5,74.35,478.83,73.91H466.72v43.14H453.86Zm12.86,45.36h13.14c13.74,0,22.46-7.54,22.46-18.91,0-12.86-9.31-18.47-22.9-18.47-6.21,0-10.49.44-12.7,1Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M533.84,83.66c.3,17.58,11.38,24.82,24.52,24.82,9.31,0,15.07-1.62,19.8-3.69l2.37,9.3c-4.58,2.07-12.56,4.59-23.94,4.59-22,0-35.16-14.63-35.16-36.2S534.14,44.06,555,44.06c23.49,0,29.55,20.39,29.55,33.54a31.27,31.27,0,0,1-.45,6.06ZM572,74.35c.15-8.12-3.4-21-18-21-13.29,0-18.91,12-19.94,21Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M644,99.91a119.76,119.76,0,0,0,1,17.14H633.32l-1-9h-.45c-4,5.61-11.67,10.64-21.86,10.64-14.48,0-21.87-10.2-21.87-20.54,0-17.29,15.37-26.74,43-26.6V70.07c0-5.76-1.63-16.55-16.25-16.4A34.47,34.47,0,0,0,596.09,59l-3-8.72c5.91-3.69,14.62-6.21,23.64-6.21C638.64,44.06,644,59,644,73.17ZM631.4,80.56c-14.18-.3-30.28,2.21-30.28,16.1,0,8.57,5.61,12.41,12.11,12.41,9.46,0,15.51-5.91,17.58-12A14.72,14.72,0,0,0,631.4,93Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M719.66,12.15V98.58c0,6.36.29,13.59.59,18.47H708.72l-.59-12.41h-.44c-3.84,8-12.41,14-24.08,14-17.29,0-30.73-14.63-30.73-36.35-.15-23.78,14.77-38.27,32.06-38.27,11.08,0,18.32,5.17,21.57,10.79h.29V12.15ZM706.8,74.65a23.15,23.15,0,0,0-.59-5.47,19.14,19.14,0,0,0-18.76-14.92C674,54.26,666,66.08,666,81.74c0,14.48,7.24,26.45,21.12,26.45,8.72,0,16.7-5.92,19.06-15.52a22.68,22.68,0,0,0,.59-5.61Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M741.72,83.66c.3,17.58,11.38,24.82,24.53,24.82,9.31,0,15.07-1.62,19.8-3.69l2.36,9.3c-4.58,2.07-12.56,4.59-23.93,4.59-22,0-35.16-14.63-35.16-36.2S742,44.06,762.85,44.06c23.49,0,29.55,20.39,29.55,33.54a32.25,32.25,0,0,1-.44,6.06Zm38.12-9.31c.15-8.12-3.4-21-18-21-13.3,0-18.91,12-20,21Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M801.61,67.85c0-8.42-.15-15.66-.59-22.31H812.4L813,59.72h.44c3.25-9.6,11.23-15.66,20-15.66a26,26,0,0,1,3.54.3V56.62a20.61,20.61,0,0,0-4.43-.29c-9.16,0-15.66,6.79-17.44,16.54a39.68,39.68,0,0,0-.44,6.06v38.12h-13Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M827.24,109.36c0-5.31,3.69-9.3,8.86-9.3s8.72,3.84,8.72,9.3-3.55,9.32-9,9.32C830.78,118.68,827.24,114.69,827.24,109.36Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M870.7,25.45c0,4.43-3.1,8-8.27,8a7.64,7.64,0,0,1-7.83-8,7.92,7.92,0,0,1,8.13-8.12A7.79,7.79,0,0,1,870.7,25.45Zm-14.48,91.6V45.54h13v71.51Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M950,80.7c0,26.45-18.47,38-35.61,38-19.2,0-34.27-14.19-34.27-36.79,0-23.79,15.81-37.83,35.46-37.83C936.11,44.06,950,59,950,80.7Zm-56.58.74c0,15.66,8.86,27.48,21.56,27.48,12.42,0,21.72-11.67,21.72-27.77,0-12.12-6.05-27.33-21.42-27.33S893.42,68,893.42,81.44Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					d: "M106.15,59.42h45.78a.76.76,0,0,1,.74.78v6.18a.76.76,0,0,1-.74.78H106.15a.76.76,0,0,1-.74-.78V60.2a.76.76,0,0,1,.74-.78"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					d: "M106.15,76.24h45.78a.76.76,0,0,1,.74.78V83.2a.76.76,0,0,1-.74.78H106.15a.76.76,0,0,1-.74-.78V77a.76.76,0,0,1,.74-.78"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					d: "M151.93,42.6a.77.77,0,0,1,.74.79v6.18a.76.76,0,0,1-.74.77H120.76a.76.76,0,0,1-.74-.77V43.39a.77.77,0,0,1,.74-.79h31.17"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					d: "M24.25,59.42H70a.76.76,0,0,1,.74.78v6.18a.76.76,0,0,1-.74.78H24.25a.76.76,0,0,1-.73-.78V60.2a.76.76,0,0,1,.73-.78"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					d: "M24.25,76.24H70a.76.76,0,0,1,.74.78V83.2A.76.76,0,0,1,70,84H24.25a.76.76,0,0,1-.73-.78V77a.76.76,0,0,1,.73-.78"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-2",
					d: "M24.25,42.61H70a.76.76,0,0,1,.74.78v6.17a.76.76,0,0,1-.74.78H24.25a.76.76,0,0,1-.73-.78V43.39a.76.76,0,0,1,.73-.78"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "cls-1",
					d: "M42.09,117.77H10.31A10.33,10.33,0,0,1,0,107.46V18.89A10.35,10.35,0,0,1,10.33,8.57h73.4A10.35,10.35,0,0,1,94,18.88V119.23c0,2,0,2,2.27-.11l9.3-8.5c4.41-4.14,6.55-4.82,12.59-4.77l44.23,0a1.81,1.81,0,0,0,1.8-1.8V22.29a1.81,1.81,0,0,0-1.8-1.8H133.62c0,1.71.11,3.45.28,5.21.37,3.88-.78,3.79-5.73,1.35l-19.57-8.9c-5.6-2.76-5-3.11.61-6.61a100.24,100.24,0,0,1,20.11-9.82c6.45-2.45,6.16-3,5.39,3.4-.14,1.14-.27,2.28-.4,3.44h31.54a10.35,10.35,0,0,1,10.31,10.31v88.58a10.34,10.34,0,0,1-10.31,10.32H121c-4.55,0-6.07,0-7.77,1.53L95.33,135.67c-6.08,5.57-13.21,3.06-13.21-5.45l0-107.94a1.81,1.81,0,0,0-1.8-1.8l-66.62,0a1.81,1.81,0,0,0-1.8,1.8v81.79a1.81,1.81,0,0,0,1.8,1.8c9.68,0,19.36,0,29,0,0-1.67-.1-3.36-.27-5.08-.37-3.88.77-3.79,5.73-1.35l19.57,8.9c5.6,2.76,5,3.12-.61,6.62a99.93,99.93,0,0,1-20.11,9.81c-6.45,2.46-6.16,3.05-5.39-3.4.14-1.18.28-2.37.41-3.57"
				})
			]
		})
	})]
});
export default SvgBetaReaderLogoAndName;
